module.exports = __webpack_public_path__ + "img/coinbankB13.6de0076d.jpg";